export default {
  width: 12,
  height: 8,
  viewBox: '0 0 12 8',
  data: '<path d="M11 1 6.015 6 1 1" fill="none" stroke="#969083" stroke-width="2" stroke-linecap="round"/>'
}
